import './header-scroll.js';
import './reveal.js';
import './variant-picker.js';
import './product-carousel.js';
import './add-to-cart.js';
import './cart-drawer.js';
import './correspondence.js';
import './search.js';

document.documentElement.classList.add('js');

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.input) return;

        const current = Number.parseInt(this.input.value || '1', 10);
        const next = button.name === 'plus' ? current + 1 : Math.max(1, current - 1);
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });
}
